// First: zod reads its config as each schema is built, and contracts builds them on import.
import "./zod-jitless.js"
import { StrictMode } from "react"
import { createRoot } from "react-dom/client"
import { AdminApp } from "./app.js"
// The ui tokens first: the admin stylesheets read --color-* and --font-sans from them.
import "@ternary/ui/styles.css"
import "./styles.css"

const root = document.querySelector("#root")

if (!root) {
  throw new Error("Missing #root element")
}

createRoot(root).render(
  <StrictMode>
    <AdminApp />
  </StrictMode>,
)
